import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_POLYGON_OPACITY } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const crown_mineral_activity: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'crown_mineral_activity',
  dataType: 'crown_mineral_activity',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Crown Mineral Activity',
  description: '~13,000 mineral activity records',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'crown_mineral_activity',
    type: LayerType.Polygon,
    style: {
      color: `hsla(30, 100%, 25%, ${DEFAULT_POLYGON_OPACITY})`,
    },
    source: {
      type: 'vector',
      minzoom: 6,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/crown_mineral_activity/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/crown_mineral_activity/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'crown_mineral_activity',
    renderAsPoints: true,
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/crown_mineral_activity',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'agreement_number',
      'tract',
      'current_status',
      'cma_type',
      'expiry_date',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'crown_mineral_activity',
    dataType: 'crown_mineral_activity',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
